import React, { ReactElement, useEffect } from "react";
import "./LegalbirdTipTapEditor.css";
import TipTapToolbar from "./Toolbar/TipTapToolbar";
import { LegalbirdTipTapEditorContent } from "./LegalbirdTipTapEditorProvider";
import { Box, SxProps } from "@mui/material";
import legalbirdTipTapEditorStyles from "./legalbirdTipTapEditorStyles";
import { ValidatorType } from "../../types/ValidatorType";
import FormHelperText from "@mui/material/FormHelperText";

export type LegalbirdTipTapEditorProps = {
  additionalToolbarActions?: ReactElement[];
  editorSx?: SxProps;
  sx?: SxProps;
  registerValidators?: Function;
  validators?: Array<ValidatorType>;
  name?: string;
  error?: boolean;
  helperText?: string;
  toolBarStickyTop?: `${number}rem`;
};

export default function LegalbirdTipTapEditor({
  additionalToolbarActions,
  editorSx,
  sx,
  registerValidators,
  validators,
  name,
  error,
  helperText,
  toolBarStickyTop,
}: LegalbirdTipTapEditorProps) {
  useEffect(() => {
    registerValidators && validators && registerValidators(name, validators);
    return () => {
      registerValidators && registerValidators(name, []);
    };
  }, []);

  return (
    <Box sx={sx}>
      <TipTapToolbar additionalActions={additionalToolbarActions} stickyTop={toolBarStickyTop} />
      <LegalbirdTipTapEditorContent sx={{ ...legalbirdTipTapEditorStyles.defaultEditor, ...editorSx }} />
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </Box>
  );
}
